import { isEmpty } from 'lodash';

export const maxDigits = length => (value, previousValue) => {
  if (isEmpty(value)) {
    return null;
  }
  return value.match(/^[0-9]+$/) && value.length <= length
    ? value
    : previousValue;
};



// WEBPACK FOOTER //
// ./app/javascript/apps/age_verification/components/forms/normalizers.js